export default __webpack_public_path__ + "static/media/TotalCalls_Icon.85e133bf.png";